import React, {
  useState,
  ReactNode,
  ReactElement,
  SetStateAction,
  Dispatch,
} from 'react'
import { formatDate } from '../../utils/utils'
import { Icon } from '../Icon'
import Menu, { MenuItemInterface } from './UIMenu'

interface AccordionItemProps {
  title: string
  date: string
  isActive: boolean
  onClick: () => void
  children: ReactNode
  isOpenMenu?: boolean
  menuItems: MenuItemInterface[]
  onClickMenu: (e: React.MouseEvent<HTMLDivElement>) => void
  isOpenMenusArray?: boolean[]
  setIsOpenMenu?: Dispatch<SetStateAction<boolean[]>> | undefined
  showIcon: boolean
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  date,
  isActive,
  onClick,
  children,
  isOpenMenu,
  menuItems,
  onClickMenu,
  setIsOpenMenu,
  isOpenMenusArray,
  showIcon,
}) => {
  return (
    <div className="w-[100%] rounded-[16px]   border ">
      <button
        className={`w-full ${isActive ? 'rounded-t-[16px]' : 'rounded-[16px]'} h-[48px]   bg-gray1 flex justify-between items-center py-2 px-4 text-left focus:outline-none`}
        onClick={onClick}
      >
        <div className="flex  items-center gap-[10px]">
          <Icon
            name={isActive ? 'IconChevronDown' : 'IconChevronRight'}
            stroke={'#02698C'}
            width={isActive ? 16 : 10}
            height={isActive ? 16 : 10}
          />
          <div className="flex w-[100%] justify-between items-center gap-[30px]">
            <span className="text-[14px]  font-medium">{formatDate(date)}</span>
            <span className="text-[14px] text-text1  font-medium">{title}</span>
          </div>
        </div>
        <div className="flex  items-center gap-[10px]">
          {showIcon && (
            <Icon
              name={'IconAttachment'}
              width={16}
              height={16}
              strokeWidth={1.5}
              stroke={'#02698C'}
            />
          )}
          <Menu
            setIsOpenMenu={setIsOpenMenu}
            isOpen={isOpenMenu}
            items={menuItems}
            isOpenMenus={isOpenMenusArray}
          >
            <div
              onClick={onClickMenu}
              className={`items-center justify-between text-white py-1 px-1 flex rounded cursor-pointer ${isOpenMenu ? 'bg-gray2 border border-gray2' : 'bg-transparent'}`}
            >
              <Icon
                name={'IconDotsVertical'}
                strokeWidth={1.2}
                stroke={'#02698C'}
                width={16}
                height={16}
              />
            </div>
          </Menu>
        </div>
      </button>
      {isActive && <div className="px-4 pt-4">{children}</div>}
    </div>
  )
}

interface AccordionProps {
  children: ReactNode
}

const Accordion: React.FC<AccordionProps> = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)

  const handleItemClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <div className="w-full flex flex-col  gap-[20px]  mx-auto">
      {React.Children?.map(children, (child, index) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as ReactElement, {
            isActive: activeIndex === index,
            onClick: () => handleItemClick(index),
          })
        }
        return null
      })}
    </div>
  )
}

export { Accordion, AccordionItem }
